import { apiClient } from '@/lib/api/client';
import { API_ENDPOINTS } from '@/lib/api/config';
import type {
  RepairDestination,
  RepairReason,
  RepairReasonsListParams,
  StoreRepairReasonRequest,
  UpdateRepairDestinationRequest,
  UpdateRepairReasonRequest
} from '../types';

const { REPAIR_DESTINATIONS } = API_ENDPOINTS;

export const repairSettingsApi = {
  public: () => apiClient.get<RepairDestination[]>(REPAIR_DESTINATIONS.PUBLIC),

  updateDestination: (id: number, data: UpdateRepairDestinationRequest) =>
    apiClient.patch<RepairDestination>(REPAIR_DESTINATIONS.UPDATE(id), data),

  listReasons: (destId: number, params?: RepairReasonsListParams) =>
    apiClient.getPaginated<RepairReason>(
      REPAIR_DESTINATIONS.LIST_REASONS(destId),
      params
    ),

  storeReason: (destId: number, data: StoreRepairReasonRequest) =>
    apiClient.post(REPAIR_DESTINATIONS.STORE_REASON(destId), data),

  updateReason: (id: number, data: UpdateRepairReasonRequest) =>
    apiClient.patch(REPAIR_DESTINATIONS.UPDATE_REASON(id), data),

  deleteReason: (id: number) =>
    apiClient.delete(REPAIR_DESTINATIONS.DELETE_REASON(id))
};
